
import React from 'react';
import Button from '../../../components/base/Button';

const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.8), rgba(30, 64, 175, 0.6)), url('https://public.readdy.ai/ai/img_res/484c971981fbc72b26c8b9d19291e8fa.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Premium <span className="text-orange-500">Office Furniture</span><br />
            Solutions in South Carolina
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Professional Office Group delivers exceptional commercial furniture with expert design, 
            reliable delivery, and professional installation services across South Carolina and surrounding states.
          </p>
          <div className="flex justify-center">
            <Button variant="secondary" size="lg" href="/quote">
              <i className="ri-calculator-line mr-2"></i>
              Get Free Quote
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
